"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PATHWAY_COURSE_STATUSES = void 0;
exports.isPathwayCourseStatus = isPathwayCourseStatus;
exports.PATHWAY_COURSE_STATUSES = [
    'completed',
    'in_progress',
    'locked',
    'available',
];
function isPathwayCourseStatus(value) {
    return typeof value === 'string' && exports.PATHWAY_COURSE_STATUSES.includes(value);
}
